export default __webpack_public_path__ + "static/media/white_itprofis_logo.570ab102.svg";